var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"mr-1",attrs:{"align":"center","justify":"end"}},[_c('ActionButtons',{attrs:{"actionButtons":_vm.getActionButtons,"dataCy":_vm.dataCy,"customDataCy":_vm.customDataCy}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }